/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type { SendMessageRequest, SendMessageResponse } from "./models";
import { sendMessageResponseSchema } from "./schemas";

export class SightlineApiClient {
  constructor(private caller: ApiCaller) {}

  async createMessage(
    payload: SendMessageRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<SendMessageResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.sightline.v1.sessions.${sessionId}.messages.create",
        variables: { sessionId: String(sessionId) },
      },
      "createMessage",
      payload,
      { schema: sendMessageResponseSchema, timeout },
    );
  }
}
